<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title">Profile</div>
    </div>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form__bent">
        <label class="form__label">Email</label>
        <input type="email" class="form__field" v-model="form.email"/><span class="form__del"></span>
      </div>
      <div class="form__bent">
        <label class="form__label">Name</label>
        <input type="text" class="form__field" v-model="form.name"/><span class="form__del"></span>
      </div>
      <div class="form__bent">
        <label class="form__label">Password</label>
        <div class="form__password">
          <input type="password" class="form__field" v-model="form.password"/><span class="form__eye"><span class="form__show"></span></span><span class="form__del"></span>
        </div>
      </div>
      <div class="form__bent">
        <label class="form__label">Repeat Password</label>
        <div class="form__password">
          <input type="password" class="form__field" v-model="form.password_confirmation"/>
          <span class="form__eye"><span class="form__show"></span></span><span class="form__del"></span>
        </div>
      </div>
      <div class="form__bent">
        <label class="form__label">Country</label>
        <vue-select id="userCountry" v-model="form.country_id" :options="getCountriesOptions()"></vue-select>
      </div>
      <div class="form__bent">
        <label class="form__label">Phone Number</label>
        <div class="form__inlet">
          <input type="text" class="form__field form__field-code" v-model="phone_prefix"/>
          <input type="text" class="form__field" v-model="form.phone"/><span class="form__del"></span>
        </div>
      </div>
      <div class="form__btn">
        <button class="btn" type="submit">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: "ModalUserCurrent",
    computed: {
      ...mapGetters([
        'getModalData',
        'getCountriesOptions',
        'getAuthUser',
      ]),
    },
    data() {
      return {
        form: {
          email: '',
          name: '',
          password: '',
          password_confirmation: '',
          country_id: 0,
          phone: ''
        },
        phone_prefix: '',
      }
    },
    watch: {
      'form.phone'(val) {
        this.form.phone = val.replace(/[^\d]/,'')
      },
      phone_prefix(val) {
        if (val.substr(0, 1) != '+')
          this.phone_prefix = '+' + this.phone_prefix
      }
    },
    mounted() {
      this.queryCountries()
      this.form = {
        email: this.getAuthUser.email,
        name: this.getAuthUser.name,
        country_id: this.getAuthUser.country_id
      }
      if (this.getAuthUser.phone) {
        let val = this.getAuthUser.phone.split(' ')
        if (val.length > 1) {
          this.phone_prefix = val[0]
          this.form.phone = val[1]
        } else {
          this.phone_prefix = '+'
          this.form.phone = this.getAuthUser.phone
        }
      }
    },
    methods: {
      ...mapActions([
        'queryCountries',
        'updateUser',
        'queryAuth',
        'setToast',
      ]),
      onSubmit() {
        if (this.form.password && this.form.password != this.form.password_confirmation) {
          this.setToast({message: 'Passwords do not match', status: 'warning'})
          return false
        }

        let data = {
          email: this.form.email,
          name: this.form.name,
          country_id: this.form.country_id,
          phone: this.phone_prefix + ' ' + this.form.phone,
        }
        if (this.form.password) {
          data.password = this.form.password
          data.password_confirmation = this.form.password_confirmation
        }

        this.updateUser([this.getAuthUser.id, data])
          .then(() => {
            this.queryAuth()
          })
      }
    }
  }
</script>

<style scoped>
  .popup { padding: 50px 100px !important }
</style>